import { defineMessages } from 'react-intl';

const translations = {
  sections: {
    password: {
      title: {
        id: 'pages.profile.sections.password.title',
        defaultMessage: 'Password',
        description: 'title of the password section',
      },
      description: {
        id: 'pages.profile.sections.password.description',
        defaultMessage: 'You can change your password by requesting a password reset.',
        description: 'title of the password section',
      },
      actions: {
        edit: {
          id: 'actions.edit',
          defaultMessage: 'Edit',
          description: 'label of the edit button',
        },
      },
      feedback: {
        resetPasswordEmailSent: {
          id: 'pages.profile.sections.password.feedback.resetPasswordEmailSent',
          defaultMessage:
            'An email has been sent to your email address. Click the link in the email to choose a different password.',
          description: 'feedback when the reset password email has been sent',
        },
        resetPasswordEmailAlreadySent: {
          id: 'pages.profile.sections.password.feedback.resetPasswordEmailAlreadySent',
          defaultMessage:
            'An email with a reset link was already. Check your inbox and spam folder or try again later.',
          description: 'feedback when the reset password email was already sent',
        },
        unknownError: {
          id: 'pages.profile.sections.password.feedback.unknownError',
          defaultMessage: 'Something went wrong, please try again later.',
          description: 'feedback',
        },
      },
    },
    twofa: {
      title: {
        id: 'pages.profile.sections.twofa.title',
        defaultMessage: 'Two factor authentication',
        description: 'title of the 2fa section',
      },
      actions: {
        configure: {
          id: 'actions.configure',
          defaultMessage: 'Configure',
          description: 'label of the configure action',
        },
        disable: {
          id: 'actions.disable',
          defaultMessage: 'Disable',
          description: 'label of the disable action',
        },
        deleteDialog: {
          title: {
            id: 'pages.profile.sections.twofa.actions.delete.dialog.title',
            defaultMessage: 'Disable two factor authentication',
            description: 'the title of the disable 2fa confirm dialog',
          },
          text: {
            id: 'pages.profile.sections.twofa.actions.delete.dialog.text',
            defaultMessage: "Are you sure you wan't to disable two factor authentication?",
            description: 'the text of the disable 2fa confirm dialog',
          },
          cancel: {
            id: 'actions.cancel',
            defaultMessage: 'Cancel',
            description: 'label of the cancel button',
          },
          disable: {
            id: 'actions.disable',
            defaultMessage: 'Disable',
            description: 'label of the disable button',
          },
        },
      },
      description: {
        id: 'pages.profile.sections.twofa.description',
        defaultMessage:
          'Configure two factor authentication to add an extra layer of security to your account.',
        description: 'description of the 2fa section',
      },
      authenticatorApp: {
        title: {
          id: 'pages.profile.sections.twofa.authenticatorApp.title',
          defaultMessage: 'Authenticator app',
          description: 'title of the authenticator app section of the 2fa section',
        },
        description: {
          id: 'pages.profile.sections.twofa.authenticatorApp.description',
          defaultMessage: 'Use the Google Authenticator app for the two factor authentication.',
          description: 'description of the authenticator app section of the 2fa section',
        },
        activeSince: {
          id: 'pages.profile.sections.twofa.authenticatorApp.activeSince',
          defaultMessage: 'Active since {date}',
          description: 'message telling at what date the authenticator app was activated',
        },
        backups: {
          title: {
            id: 'pages.profile.sections.twofa.authenticatorApp.backups.title',
            defaultMessage: 'Backup methods',
            description: 'title of the subsection backups of the section authenticator app',
          },
          channels: {
            email: {
              id: 'pages.profile.sections.twofa.backupMethods.email',
              defaultMessage: 'Email',
              description: 'subtitle for the backup method email',
            },
            sms: {
              id: 'pages.profile.sections.twofa.backupMethods.sms',
              defaultMessage: 'SMS',
              description: 'subtitle for the backup method sms',
            },
          },
        },
      },
    },
  },
  form: {
    steps: {
      backup: {
        title: {
          id: 'pages.profile.form.steps.backup.title',
          defaultMessage: 'Backup method',
          description: 'title of the backup method step in the 2fa form',
        },
      },
      connect: {
        title: {
          id: 'pages.profile.form.steps.connect.title',
          defaultMessage: 'Connect authenticator',
          description: 'title of the backup method step in the 2fa form',
        },
      },
      success: {
        title: {
          id: 'pages.profile.form.steps.success.title',
          defaultMessage: 'Authenticator configured',
          description: 'title of the backup method step in the 2fa form',
        },
      },
    },
  },
};

export default defineMessages(translations);
